// TSS vite/03 §"Query keys convention". Entity-first, scope a la derecha.
// El estado del evento cachea por public_token.
export const eventKeys = {
    all:       ['event'],
    dashboard: (token) => ['event', token, 'dashboard'],
};
